import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { components } from "@/api/types";
import { apiUpload, qk } from "@/shared/api";

type ProfileResponse = components["schemas"]["ProfileResponse"];

/**
 * Загрузка своей аватарки.
 *
 * `apiUpload`, а не `apiPost`: тело multipart, и в сгенерированных типах поле
 * `file` описано строкой — `File` туда компилятор не пустит.
 *
 * Ответ — профиль целиком, поэтому кэш заменяется через `setQueryData`: адрес
 * картинки меняется вместе с ключом объекта, и лишний GET за теми же данными
 * ничего не добавил бы.
 */
export function useUploadAvatar() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => apiUpload<ProfileResponse>("/api/v1/profile/avatar", { file }),
    onSuccess: (profile) => {
      client.setQueryData(qk.profile(), profile);
    },
  });
}
